module.exports = __webpack_public_path__ + "img/step33_a_pull_out_fabric.f18895fa.png";